import React, { useEffect, useState, useRef } from 'react';
import baseURL from '../url';
import './Products.css';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import ProductosLoading from '../ProductosLoading/ProductosLoading';
import { Link as Anchor, useNavigate, useLocation } from "react-router-dom";
import { faHeart } from '@fortawesome/free-solid-svg-icons';
import moneda from '../moneda';

SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function Products() {
    const api = baseURL;
    const [categorias, setCategorias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fixedCategories, setFixedCategories] = useState(false);
    const categoriasRefs = useRef([]);
    const categoriasInputRef = useRef(null);
    const swiperRef = useRef(null);
    const [productos, setProductos] = useState([]);
    const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('Todo');
    const [subcategorias, setSubCategorias] = useState([]);
    const [subcategoriaSeleccionada, setSubcategoriaSeleccionada] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const [likesCounts, setLikesCounts] = useState({});
    const isSoldOut = (item) => {
        const st = String(item?.status||'').toLowerCase();
        if (st === 'disponible') return false;
        if (st === 'agotado') return true;
        const s = Number(item?.stock || 0);
        let sumQty = 0;
        try { const q = JSON.parse(item?.itemsQty||'[]'); if (Array.isArray(q)) { for (let i=0;i<Math.min(10,q.length);i++){ sumQty += parseInt(q[i]||0,10)||0; } } } catch(_){ }
        const available = (s > 0) || (sumQty > 0);
        return !available;
    };

    const handleClickCategoria = (categoria) => {
        setCategoriaSeleccionada(categoria);
        setSubcategoriaSeleccionada('Todo');
        const pos = Math.round(window.scrollY || 0);
        if (categoria === 'Todo') {
            navigate(`?pos=${pos}`, { replace: false, state: { restoreScroll: pos } });
            return;
        }
        navigate(`?categoria=${categoria}&pos=${pos}`, { replace: false, state: { restoreScroll: pos } });
    };

    const handleClickSubcategoria = (subcategoria) => {
        setSubcategoriaSeleccionada(subcategoria);
        const pos = Math.round(window.scrollY || 0);
        if (subcategoria === 'Todo') {
            navigate(`?categoria=${categoriaSeleccionada}&pos=${pos}`, { replace: false, state: { restoreScroll: pos } });
            return;
        }
        navigate(`?categoria=${categoriaSeleccionada}&subcategoria=${subcategoria}&pos=${pos}`, { replace: false, state: { restoreScroll: pos } });
    };

    useEffect(() => {
        cargarProductos();
        cargarCategorias();
        cargarSubCategoria();
        window.addEventListener('scroll', handleScroll);
        const onStorage = (e) => { try{ if (e.key === 'stockUpdateFlag') { cargarProductos(); } }catch(_){ } };
        const onStockUpdated = () => { try{ cargarProductos(); }catch(_){ } };
        window.addEventListener('storage', onStorage);
        window.addEventListener('stock-updated', onStockUpdated);
        let pollId = null;
        const startPoll = () => {
            if (pollId) return; pollId = setInterval(() => { cargarProductos(); }, 6000);
        };
        const stopPoll = () => { if (pollId) { clearInterval(pollId); pollId = null; } };
        startPoll();
        const onVisibility = () => { if (document.hidden) { stopPoll(); } else { startPoll(); } };
        document.addEventListener('visibilitychange', onVisibility);
        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('storage', onStorage);
            window.removeEventListener('stock-updated', onStockUpdated);
            document.removeEventListener('visibilitychange', onVisibility);
            if (pollId) { clearInterval(pollId); pollId = null; }
        };
    }, []);

    const handleScroll = () => {
        if (categoriasInputRef.current) {
            const bannerElement = document.querySelector('.BannerContain');
            const bannerHeight = bannerElement ? bannerElement.offsetHeight : 0;

            if (window.scrollY > categoriasInputRef.current.offsetTop && window.scrollY > bannerHeight) {
                setFixedCategories(true);
            } else {
                setFixedCategories(false);
            }
        }
    };



    const cargarProductos = () => {
        fetch(`${api}/productosGet.php`, { method:'GET' })
            .then(r=>r.text())
            .then(t=>{ try{ const d=JSON.parse(t); setProductos(d.productos||[]); setLoading(false); }catch(_){ setProductos([]); setLoading(false);} })
            .catch(()=>{});
    };

    const cargarCategorias = () => {
        fetch(`${api}/categoriasGet.php`, { method:'GET' })
            .then(r=>r.text())
            .then(t=>{ try{ const data=JSON.parse(t); const categoriasOrdenadas = (data?.categorias || [])?.sort((a, b) => a.orden - b.orden); setCategorias(categoriasOrdenadas); }catch(_){ setCategorias([]);} })
            .catch(()=>{});
    };

    const cargarSubCategoria = () => {
        fetch(`${api}/subCategoriaGet.php`, { method:'GET' })
            .then(r=>r.text())
            .then(t=>{ try{ const data=JSON.parse(t); setSubCategorias(data.subcategorias || []); }catch(_){ setSubCategorias([]);} })
            .catch(()=>{});
    };

    useEffect(() => {
        if (!productos || productos.length === 0) return;
        fetch(`${api}/likesGet.php`).then(r=>r.json()).then(d=>{
            setLikesCounts(d.counts || {});
        }).catch(()=>{});
        const i = setInterval(() => {
            fetch(`${api}/likesGet.php`).then(r=>r.json()).then(d=>{
                setLikesCounts(d.counts || {});
            }).catch(()=>{});
        }, 10000);
        return () => clearInterval(i);
    }, [productos]);

    const addLike = async (item) => {
        try {
            const liked = JSON.parse(localStorage.getItem('likedProducts')||'[]');
            if (liked.includes(item.idProducto)) return;
            const res = await fetch(`${api}/likeAdd.php`, { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ idProducto: item.idProducto, titulo: item.titulo }) });
            const d = await res.json();
            localStorage.setItem('likedProducts', JSON.stringify([...liked, item.idProducto]));
            setLikesCounts(prev => ({ ...prev, [item.idProducto]: (prev[item.idProducto] || 0) + 1 }));
        } catch(_){ }
    };
  const obtenerImagen = (item) => {
        for (let i = 1; i <= 14; i++) {
            const key = `imagen${i}`;
            if (item?.[key]) return item[key];
        }
        return null;
  };
  const normalizeUrl = (u) => {
    if (!u) return '';
    try {
      const isHttp = /^http:\/\//i.test(u);
      const isHttps = /^https:\/\//i.test(u);
      const wantedHttps = (window.location.protocol === 'https:');
      if (wantedHttps && isHttp) return u.replace(/^http:\/\//i, 'https://');
      if (!wantedHttps && isHttps && /^https?:\/\//i.test(u)) return u; // keep
      return u;
    } catch(_) { return u; }
  };
  const resolveImage = (raw) => {
    try{
      if (!raw) return `${api}/logo.png`;
      if (/^https?:\/\//i.test(raw)){
        const url = new URL(raw);
        return `${api}/${String(url.pathname||'').replace(/^\//,'')}`;
      }
      return `${api}/${String(raw||'').replace(/^\//,'')}`;
    }catch(_){ return `${api}/logo.png`; }
  };

  const getCategoriaName = (id) => {
    const c = categorias?.find(x => x.idCategoria === id);
    return c ? c.categoria : '';
  };
  const getSubCategoriaName = (id) => {
    const s = subcategorias?.find(x => x.idSubCategoria === id);
    return s ? s.subcategoria : '';
  };

    const categoriasConProductos = categorias?.filter(categoria =>
        productos?.some(producto => producto?.idCategoria === categoria?.idCategoria)
    );

    useEffect(() => {
        const s = location.state;
        if (s && s.restoreScroll !== undefined) {
            setTimeout(() => window.scrollTo(0, s.restoreScroll || 0), 0);
            navigate(`${location.pathname}${location.search || ''}`, { replace: true, state: {} });
        }
        const params = new URLSearchParams(location.search);
        const catId = params.get('categoria');
        const subId = params.get('subcategoria');
        const pos = Number(params.get('pos'));
        if (catId) {
            setCategoriaSeleccionada(catId === 'Todo' ? 'Todo' : Number(catId));
        }
        if (subId) {
            setSubcategoriaSeleccionada(subId === 'Todo' ? 'Todo' : Number(subId));
        }
        if (!Number.isNaN(pos)) {
            setTimeout(() => window.scrollTo(0, pos || 0), 0);
        }
    }, [location.search]);

    return (
        <div className='ProductsContain'>
            
            {productos?.length > 0 && (
                <div className={`categoriasInputs ${fixedCategories ? 'fixed' : ''}`} id='FlexIn' ref={categoriasInputRef}>
                    <div className='categoriasInputsFilter' >
                        <input
                            type="button"
                            value="Todo"
                            onClick={() => handleClickCategoria('Todo')}
                            style={{
                                backgroundColor: categoriaSeleccionada === 'Todo' ? '#023992' : '',
                                color: categoriaSeleccionada === 'Todo' ? '#fff' : '',
                            }}
                        />
                        {categoriasConProductos?.map(({ categoria, idCategoria }) => (
                            <div className='columnInput' key={idCategoria}>
                                <input
                                    type="button"
                                    value={categoria}
                                    onClick={() => handleClickCategoria(idCategoria)}
                                    style={{
                                        backgroundColor: categoriaSeleccionada === idCategoria ? '#023992' : '',
                                        color: categoriaSeleccionada === idCategoria ? '#fff' : '',
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                    {categoriaSeleccionada !== 'Todo' &&
                        subcategorias?.filter(subcategoria =>
                            subcategoria.idCategoria === categoriaSeleccionada &&
                            productos.some(producto => producto.idSubCategoria === subcategoria.idSubCategoria)
                        )?.length > 0 && ( // Verifica si hay subcategorías filtradas
                            <div className='categoriasInputsFilter' id='subcategoriasInputs'>
                                <input
                                    type="button"
                                    value="Todo"
                                    onClick={() => handleClickSubcategoria('Todo')}
                                    style={{
                                        borderBottom: subcategoriaSeleccionada === 'Todo' ? '2px solid #023992' : '',
                                        color: subcategoriaSeleccionada === 'Todo' ? '#023992' : '',
                                    }}
                                    id='subcategoriaInput'
                                />

                                {subcategorias
                                    ?.filter(subcategoria =>
                                        subcategoria.idCategoria === categoriaSeleccionada &&
                                        productos.some(producto => producto.idSubCategoria === subcategoria.idSubCategoria)
                                    )
                                    ?.map(subcategoria => (
                                        <div key={subcategoria.idSubCategoria}>
                                            <input
                                                type="button"
                                                value={subcategoria.subcategoria}
                                                onClick={() => handleClickSubcategoria(subcategoria.idSubCategoria)}
                                                style={{
                                                    borderBottom: subcategoriaSeleccionada === subcategoria.idSubCategoria ? '2px solid #023992' : '',
                                                    color: subcategoriaSeleccionada === subcategoria.idSubCategoria ? '#023992' : '',
                                                }}
                                                id='subcategoriaInput'

                                            />
                                        </div>
                                    ))}
                            </div>
                        )}



                </div>
            )}


            {loading ? (
                <ProductosLoading />
            ) : (
                <div className='Products'>
                    {categoriaSeleccionada === 'Todo' && (
                        <>
                            {productos?.some(item => item.masVendido === "si") && (
                                <div className='categoriSection'>
                                    <Swiper
                                        effect={'coverflow'}
                                        grabCursor={true}
                                        slidesPerView={'auto'}
                                        id='swiper_container_products'
                                        autoplay={{ delay: 3000 }}
                                    >
                                        {productos?.filter(item => item.masVendido === "si")?.slice(0, 20)?.map(item => (
                                            <SwiperSlide key={item.idProducto} id='SwiperSlide-scroll-products-masvendidos'>
                                                <Anchor className='cardProdcutmasVendido' to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`} state={{ from: `${location.pathname}${location.search || ''}` }}>
                                                    {isSoldOut(item) && (<span className='badge-soldout-chip-corner'>Agotado</span>)}
                                                    {(() => { const raw = obtenerImagen(item); const src = resolveImage(raw); return (
                                                      <img loading="lazy" src={src} alt={item.producto || 'Producto'} onError={(e)=>{ try{ e.currentTarget.src = `${api}/logo.png`; }catch(_){ } }} />
                                                    ); })()}
                                                    <h6 className='masVendido'>Más Vendido</h6>
                                                    <div className='cardText'>
                                                        <h4>{String(item.titulo||'').trim() || String(item.producto||'').trim() || 'Producto'}</h4>
                                                        
                                                        <div className='itemsDetail'>
                                                            {(() => { const name = getCategoriaName(item.idCategoria); return (name && name !== '0') ? (<span>{name}</span>) : null; })()}
                                                            {(() => { const name = getSubCategoriaName(item.idSubCategoria); return (name && name !== '0') ? (<span>{name}</span>) : null; })()}
                                                        </div>
                                                        <div className='deFLexPrice'>
                                                            {Number(item?.precio) > 0 ? (
                                                                <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                            ) : (
                                                                <h5>Consultar</h5>
                                                            )}
                                                            {(Number(item?.precioAnterior) >= 1 && Number(item?.precio) > 0 && item.precioAnterior !== undefined) && (
                                                                <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {(() => { const likedArr = JSON.parse(localStorage.getItem('likedProducts')||'[]'); const isLiked = likedArr.includes(item.idProducto); return (
                                                    <button className={`like-btn ${isLiked ? 'liked ' : ''}${isSoldOut(item) ? 'like-masvendido-below' : 'like-masvendido-right'}`} onClick={(e)=>{ e.preventDefault(); addLike(item); }} aria-label='Me Gusta'>
                                                        <FontAwesomeIcon icon={faHeart} />
                                                        {(likesCounts[item.idProducto] || 0) > 0 && (
                                                            <span className='like-count'>{likesCounts[item.idProducto]}</span>
                                                        )}
                                                    </button>
                                                    ); })()}
                                                </Anchor>
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            )}

                            {categoriasConProductos?.map(({ categoria, idCategoria }) => (
                                <div key={idCategoria} className='categoriSection' ref={ref => categoriasRefs.current[categorias.findIndex(cat => cat.idCategoria === idCategoria)] = ref}>
                                    <div className='deFlexTitlesection'>
                                        <h3>{categoria}</h3>
                                        <button onClick={() => handleClickCategoria(idCategoria)}>
                                            Ver más
                                        </button>
                                    </div>

                                    <Swiper
                                        effect={'coverflow'}
                                        grabCursor={true}
                                        slidesPerView={'auto'}
                                        id='swiper_container_products'
                                    >


                                        {productos?.filter(item => item.idCategoria === idCategoria)?.map(item => (
                                            <SwiperSlide id='SwiperSlide-scroll-products' key={item.idProducto}>
                                                <Anchor className='cardProdcut' key={item.idProducto} to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`} state={{ from: `${location.pathname}${location.search || ''}` }}>
                                                    {isSoldOut(item) && (<span className='badge-soldout-chip-corner'>Agotado</span>)}
                                                    {(() => { const raw = obtenerImagen(item); const src = resolveImage(raw); return (
                                                      <img loading="lazy" src={src} alt={item.producto || 'Producto'} onError={(e)=>{ try{ e.currentTarget.src = `${api}/logo.png`; }catch(_){ } }} />
                                                    ); })()}
                                                    <div className='cardText'>
                                                        <h4>{String(item.titulo||'').trim() || String(item.producto||'').trim() || 'Producto'}</h4>
                                                        
                                                        <div className='itemsDetail'>
                                                            {(() => { const name = getCategoriaName(item.idCategoria); return (name && name !== '0') ? (<span>{name}</span>) : null; })()}
                                                            {(() => { const name = getSubCategoriaName(item.idSubCategoria); return (name && name !== '0') ? (<span>{name}</span>) : null; })()}
                                                        </div>
                                                        <div className='deFLexPrice'>
                                                            {Number(item?.precio) > 0 ? (
                                                                <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                            ) : (
                                                                <h5>Consultar</h5>
                                                            )}
                                                            {(Number(item?.precioAnterior) >= 1 && Number(item?.precio) > 0 && item.precioAnterior !== undefined) && (
                                                                <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                            )}
                                                            <FontAwesomeIcon icon={faAngleDoubleRight} className='iconCard' />
                                                        </div>
                                                    </div>
                                                    {(() => { const likedArr = JSON.parse(localStorage.getItem('likedProducts')||'[]'); const isLiked = likedArr.includes(item.idProducto); return (
                                                    <button className={`like-btn ${isLiked ? 'liked ' : ''}${isSoldOut(item) ? 'like-below-right' : 'like-top-right'}`} onClick={(e)=>{ e.preventDefault(); addLike(item); }} aria-label='Me Gusta'>
                                                        <FontAwesomeIcon icon={faHeart} />
                                                        {(likesCounts[item.idProducto] || 0) > 0 && (
                                                            <span className='like-count'>{likesCounts[item.idProducto]}</span>
                                                        )}
                                                    </button>
                                                    ); })()}
                                                </Anchor>
                                            </SwiperSlide>
                                        ))}

                                    </Swiper>
                                </div>

                            ))}
                        </>
                    )}

                    <div className='categoriSectionSelected'>
                        {productos
                            ?.filter(item => {
                                // Si "Todo" está seleccionado en subcategoría, muestra todos los productos de la categoría
                                if (subcategoriaSeleccionada === 'Todo' || !subcategoriaSeleccionada) {
                                    return item.idCategoria === categoriaSeleccionada;
                                }
                                // Si hay subcategoría seleccionada, filtra por subcategoría
                                return item.idSubCategoria === subcategoriaSeleccionada;
                            })
                            ?.map(item => (
                                <Anchor key={item.idProducto} to={`/producto/${item.idProducto}/${item.titulo.replace(/\s+/g, '-')}`} state={{ from: `${location.pathname}${location.search || ''}` }}>
                                    <div className='cardProdcutSelected'>
                                        {isSoldOut(item) && (<span className='badge-soldout-chip-corner'>Agotado</span>)}
                                        {(() => { const raw = obtenerImagen(item); const src = resolveImage(raw); return (
                                          <img loading="lazy" src={src} alt={item.producto || 'Producto'} onError={(e)=>{ try{ e.currentTarget.src = `${api}/logo.png`; }catch(_){ } }} />
                                        ); })()}
                                        <div className='cardTextSelected'>
                                            <h4>{String(item.titulo||'').trim() || String(item.producto||'').trim() || 'Producto'}</h4>
                                            
                                            <div className='itemsDetail'>
                                                {(() => { const name = getCategoriaName(item.idCategoria); return (name && name !== '0') ? (<span>{name}</span>) : null; })()}
                                                {(() => { const name = getSubCategoriaName(item.idSubCategoria); return (name && name !== '0') ? (<span>{name}</span>) : null; })()}
                                            </div>
                                            <div className='deFLexPrice'>
                                                {Number(item?.precio) > 0 ? (
                                                    <h5> {moneda} {String(item?.precio)?.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                ) : (
                                                    <h5>Consultar</h5>
                                                )}
                                                {(Number(item?.precioAnterior) >= 1 && Number(item?.precio) > 0 && item.precioAnterior !== undefined) && (
                                                    <h5 className='precioTachado'>{moneda} {`${item?.precioAnterior}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}</h5>
                                                )}
                                                <FontAwesomeIcon icon={faAngleDoubleRight} className='iconCard' />
                                            </div>
                                        </div>
                                        {(() => { const likedArr = JSON.parse(localStorage.getItem('likedProducts')||'[]'); const isLiked = likedArr.includes(item.idProducto); return (
                                        <button className={`like-btn ${isLiked ? 'liked ' : ''}${isSoldOut(item) ? 'like-below-right' : 'like-top-right'}`} onClick={(e)=>{ e.preventDefault(); addLike(item); }} aria-label='Me Gusta'>
                                            <FontAwesomeIcon icon={faHeart} />
                                            {(likesCounts[item.idProducto] || 0) > 0 && (
                                                <span className='like-count'>{likesCounts[item.idProducto]}</span>
                                            )}
                                        </button>
                                        ); })()}
                                    </div>
                                </Anchor>
                            ))}
                    </div>


                </div>
            )}
        </div>
    );
}
